import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { LaurelWreath } from "@roman/shared/components/Icons";

interface RulesModelProps {
  isShowRules: boolean;
  setIsShowRules: (value: boolean) => void;
}

export const RulesModel = ({ isShowRules, setIsShowRules }: RulesModelProps) => {
  return (
    <Dialog open={isShowRules} onOpenChange={setIsShowRules}>
      <DialogContent className="[&>button]:hidden w-[360px] p-0 ring-0 ring-transparent">
        <div className="flex flex-col">
          <div className="bg-orange relative h-[71px] overflow-hidden rounded-tl-lg rounded-tr-lg flex items-center justify-center">
            <div className="text-white text-center text-[24px] font-bold leading-[35px] z-10">ランキングのルール</div>
            <LaurelWreath color="#ff9742" className="absolute w-[200px] h-[150px] top-0" />
          </div>

          <div className="w-[320px] h-[60vh] mx-5 mt-[31px] overflow-auto">
            <img src="/assets/ranking_rules.png" alt="Ranking Rules" />
          </div>

          <div className="mb-[21px] mt-[31px] mx-[30px] flex justify-center items-center">
            <Button
              className="text-base underline"
              variant="link"
              onClick={() => {
                setIsShowRules(false);
              }}
            >
              閉じる
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
